document.addEventListener('DOMContentLoaded', () => {
  var progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;
  var pathLength = progressPath.getTotalLength();

  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';

  var lastProgress = null;
  // the scrollable height is read only when the page or window changes size, never while scrolling
  var scrollable = 1;

  function measure() {
    scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  }

  function getScrollY() {
    return window.scrollY || window.pageYOffset;
  }

  function updateProgress() {
    var progress = pathLength - (getScrollY() * pathLength) / scrollable;
    if (lastProgress !== progress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
  }

  // once per frame, only while the page scrolls (this used to run on every frame, forever, and its
  // reads of the page height made the browser lay out the whole page each frame - scrolling stuttered)
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      updateProgress();
    });
  }

  function onResize() {
    measure();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  // images, lazy sections and "Show more" change the page height
  if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(document.body);
  measure();
  updateProgress();
});
